import React from 'react'

import { Trans } from 'react-i18next'
import { GlobalNotificationNoCCDaysLeftButton } from '../GlobalNotification.styled'
import { useNavigate } from 'react-router-dom'
import { useFrontEndEventTrackingService } from '@clickcease/cc-client-components-lib'
import { addDays, differenceInDays } from 'date-fns'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { useNoCreditCardPopUpSplit } from 'Features/pricing/hooks/useNoCreditCardPopUpSplit'

export const AccountCloseNotification = () => {
  const navigate = useNavigate()
  const noCreditCardPopUp = useNoCreditCardPopUpSplit()
  const { track } = useFrontEndEventTrackingService()
  const { data: planDetails } = useGetPlansDetails()

  const handleClick = () => {
    track(['segment'], `Trial ended top banner link click`, {})
    navigate('/account-settings', {
      state: { openPaymentMethod: true, origin: 'trialEndedBanner' },
    })
  }

  const transComponent = {}
  transComponent[noCreditCardPopUp ? 1 : 3] = (
    <GlobalNotificationNoCCDaysLeftButton
      role={'button'}
      tabIndex={0}
      onKeyDown={() => {}}
      onClick={handleClick}
    >
      here
    </GlobalNotificationNoCCDaysLeftButton>
  )

  return (
    <Trans
      ns="general"
      i18nKey={
        noCreditCardPopUp
          ? 'global_notifications.account_will_be_closed'
          : 'global_notifications.insert_credit_card'
      }
      values={{
        days: differenceInDays(addDays(new Date(planDetails?.noCreditCard || ''), 22), new Date()),
      }}
      components={transComponent}
    />
  )
}
